import { Observable, shareReplay, Subject } from "rxjs";

export class ExhibitorsFilter {
  static intances: {
    [name: string]: ExhibitorsFilter
  } = {};

  private _filteredExhibitors$: Subject<ExhibitorEntry[]> = new Subject<ExhibitorEntry[]>();
  filteredExhibitors$: Observable<ExhibitorEntry[]> = this._filteredExhibitors$.asObservable().pipe(shareReplay(1));

  private _filteredExhibitorsCount$: Subject<number> = new Subject<number>();
  filteredExhibitorsCount$: Observable<number> = this._filteredExhibitorsCount$.asObservable();

  constructor(name: string, private _filter: (exhibitors: ExhibitorEntry[]) => ExhibitorEntry[]) {
    ExhibitorsFilter.intances[name] = this;
  }

  filter(exhibitors: ExhibitorEntry[]): ExhibitorEntry[] {
    const filteredExhibitors = this._filter(exhibitors);
    this._filteredExhibitors$.next(filteredExhibitors);
    this._filteredExhibitorsCount$.next(filteredExhibitors.length);
    return filteredExhibitors;
  }
}
